export default __webpack_public_path__ + "static/media/Nel_Logo.13953228.png";